module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: 'https://project-1317108076.cos.ap-chengdu.myqcloud.com/a982f66485db577d899fb943f0545a8.jpg',
	bg2: 'https://project-1317108076.cos.ap-chengdu.myqcloud.com/9de8aa5c4779838fa2c60c0a76214e2.jpg',
	bg3: 'https://project-1317108076.cos.ap-chengdu.myqcloud.com/7de6d621226bc68c28a61d83c0e3865.png',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: 'HY-LPL\'s Blog'
}
